export default __webpack_public_path__ + "static/media/153.b308aa1a.png";